import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfHyperlinkIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfFormIcon used to disply Hyperlink icon
 * @param props - CcfHyperlinkIconProps
 * @example -- <CcfHyperlinkIcon />
 */
export function CcfHyperlinkIcon(props: CcfHyperlinkIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g id="Editor/Hyperlink">
        <g id="Vector">
          <path
            d="M14.7985 1.21006C13.1978 -0.403353 10.5301 -0.403353 8.8624 1.21006L6.79501 3.29388C7.4618 3.29388 8.12909 3.29388 8.72935 3.49556L9.92987 2.2855C10.9968 1.27712 12.6646 1.27712 13.665 2.2855C14.1987 2.82347 14.4653 3.49556 14.4653 4.16764C14.4653 4.90729 14.1987 5.57938 13.665 6.04979L10.4636 9.34367C9.39664 10.4191 7.19568 10.1504 6.19525 9.07494C6.19525 9.07494 5.79507 8.73864 5.59499 8.73864C5.3949 8.73864 5.12828 9.07494 5.12828 9.07494C5.12828 9.07494 4.79464 9.41123 4.79464 9.61291C4.79464 9.88164 4.9282 10.0163 5.12828 10.1509C5.92863 10.9576 7.52933 11.6297 8.66332 11.6297C9.79731 11.6297 10.8643 11.1593 11.5981 10.4196L14.7995 7.19279C16.4002 5.51232 16.4002 2.82297 14.7995 1.20955L14.7985 1.21006Z"
            fill={props.fillColor ? props.fillColor : '#526B7A'}
          />
          <path
            d="M1.19258 14.7899C2.79327 16.4034 5.46093 16.4034 7.12865 14.7899L9.19605 12.7061C8.52926 12.7061 7.86197 12.7061 7.26171 12.5044L6.06119 13.7145C4.99423 14.7229 3.3265 14.7229 2.32607 13.7145C1.79234 13.1765 1.52572 12.5044 1.52572 11.8324C1.52572 11.0927 1.79234 10.4206 2.32607 9.95021L5.52746 6.65633C6.59442 5.58089 8.52876 5.84963 9.59572 6.92507C9.59572 6.92507 9.9959 7.26136 10.196 7.26136C10.3961 7.26136 10.6627 6.92507 10.6627 6.92507C10.6627 6.92507 10.9963 6.58877 10.9963 6.38709C10.9963 6.11836 10.8628 5.98374 10.6627 5.84912C9.86234 5.04242 8.52826 4.37033 7.39477 4.37033C6.26128 4.37033 5.26034 4.77368 4.45999 5.58039L1.25861 8.80721C-0.408616 10.4877 -0.408116 13.1765 1.19258 14.7899Z"
            fill={props.fillColor ? props.fillColor : '#526B7A'}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfHyperlinkIcon;
